import React, {createContext} from 'react'

const {Provider, Consumer} = createContext()

export default Consumer;
export {Provider};